export type { LinkProps } from './Link'
export { Link } from './Link'
